export const WINDOW_DRAG_CONSTANTS = {
  EDGE_THRESHOLD: 40,
  TITLE_BAR_HEIGHT: 44,
  DRAG_RESTART_DELAY_MAXIMIZED: 0,
  DRAG_RESTART_DELAY_SNAPPED: 0,
  DRAG_DISTANCE_THRESHOLD: 10,
  DEFAULT_Y_POSITION: 20
} as const
